var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_21026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.49707H0.5C0.223437 1.49707 0 1.72051 0 1.99707V11.9971C0 12.2736 0.223437 12.4971 0.5 12.4971H13.5C13.7766 12.4971 14 12.2736 14 11.9971V1.99707C14 1.72051 13.7766 1.49707 13.5 1.49707ZM12.875 11.3721H1.125V10.7486L3.28906 8.18145L5.63438 10.9627L9.28281 6.6377L12.875 10.8971V11.3721ZM12.875 9.34395L9.37813 5.19707C9.32812 5.1377 9.2375 5.1377 9.1875 5.19707L5.63438 9.40957L3.38438 6.74238C3.33438 6.68301 3.24375 6.68301 3.19375 6.74238L1.125 9.19551V2.62207H12.875V9.34395ZM3.75 6.12207C3.93057 6.12207 4.10937 6.08651 4.27619 6.01741C4.44301 5.9483 4.59459 5.84702 4.72227 5.71934C4.84995 5.59166 4.95123 5.44008 5.02033 5.27326C5.08943 5.10644 5.125 4.92764 5.125 4.74707C5.125 4.5665 5.08943 4.3877 5.02033 4.22088C4.95123 4.05406 4.84995 3.90248 4.72227 3.7748C4.59459 3.64712 4.44301 3.54584 4.27619 3.47674C4.10937 3.40764 3.93057 3.37207 3.75 3.37207C3.38533 3.37207 3.03559 3.51694 2.77773 3.7748C2.51987 4.03266 2.375 4.3824 2.375 4.74707C2.375 5.11174 2.51987 5.46148 2.77773 5.71934C3.03559 5.97721 3.38533 6.12207 3.75 6.12207ZM3.75 4.30957C3.99219 4.30957 4.1875 4.50488 4.1875 4.74707C4.1875 4.98926 3.99219 5.18457 3.75 5.18457C3.50781 5.18457 3.3125 4.98926 3.3125 4.74707C3.3125 4.50488 3.50781 4.30957 3.75 4.30957Z",
    fill: "currentColor",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_21026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMedia);
export default __webpack_public_path__ + "static/media/manage_media.f4e6619992a9f0289c16c29023a2604d.svg";
export { ForwardRef as ReactComponent };